import { NIKE_URL } from "@/constants/url";
import { Lang } from "@/data/translation";
import { z } from "zod";

type ChipBasicInfoParams = {
  symbol: string;
  lang: Lang;
  quarterAmount?: number;
};

const basicInfoDataSchema = z.object({
  cashSurplus: z.number().nullish(),
  cashNetIn: z.number().nullish(),
  cashNetOut: z.number().nullish(),
  addInstNum: z.number().nullish(),
  addTotalCash: z.number().nullish(),
  buildInstNum: z.number().nullish(),
  buildTotalCash: z.number().nullish(),
  reduceInstNum: z.number().nullish(),
  reduceTotalCash: z.number().nullish(),
  cleanInstNum: z.number().nullish(),
  cleanTotalCash: z.number().nullish(),
  date: z.string().nullish(),
});

export const ChipBasicInfoResponseSchema = z.object({
  data: z.union([basicInfoDataSchema, basicInfoDataSchema.array()]),
  message: z.string(),
});

export type ChipBasicInfo = z.infer<typeof ChipBasicInfoResponseSchema>["data"];

export const getChipBasicInfo = async ({
  symbol,
  lang,
  quarterAmount,
}: ChipBasicInfoParams): Promise<ChipBasicInfo> => {
  const endpoint = `/chip-basic-info/${symbol}${
    quarterAmount ? `?recentQuarters=${quarterAmount}` : ""
  }`;
  const res = await fetch(`${NIKE_URL}${endpoint}`, {
    method: "GET",
    headers: { "Accept-Language": lang },
  });
  if (!res.ok) throw new Error(`API failed (${endpoint})`);
  return ChipBasicInfoResponseSchema.parse(await res.json()).data;
};
